import React from "react";
import { Link } from "react-router-dom";
import Footer from "../Footer/Footer";
import Navbar from "../Navbar/Navbar";


function Home() {
  return (
    <div>
      <div>
        <div className="container">
          <Navbar />
          <div className="card-2">
            <h1>
              Ташкентский <br /> Фармацевтический Институт
            </h1>
            <br />
            <br />
            <br />
            <br />
            <p>
              Ташкентский фармацевтический институт был создан 16 июля 1937 года
              приказом <br /> Народного комиссариата здравоохранения Республики
              Узбекистан № 155.
            </p>
          </div>
          <div className="container__title">
            <div className="title__partner">
              <h1>Факультеты</h1>
            </div>
          </div>
          <div className="card-3">
            <div className="box-1 ">
              <Link to={'/pharmacy'} className="for__bg">
                <div className="box1">
                  <img src="assets/img/Mask Group.png" alt />
                  <h2>Факультет фармации</h2>
                  <img src="assets/img/Arrow 1.png" alt />
                </div>
              </Link>
              <br />
              <Link to={'/industrial'} className="for__bg">
                <div className="box1">
                  <img src="assets/img/Mask Group (1).png" alt />
                  <h2>Факультет промышленной фармации</h2>
                  <img src="assets/img/Arrow 1.png" alt />
                </div>
              </Link>
            </div>
            <br />
            <div className="box-1 ">
              <Link to={'/retraining'} className="for__bg">
                <div className="box1">
                  <img src="assets/img/Mask Group.png" alt />
                  <h2>Факультет переподготовка фармацевтов</h2>
                  <img src="assets/img/Arrow 1.png" alt />
                </div>
              </Link>
              <br />
              <Link to={'/magistr'} className="for__bg">
                <div className="box1">
                  <img src="assets/img/Mask Group (1).png" alt />
                  <h2>Магистратура</h2>
                  <img src="assets/img/Arrow 1.png" alt />
                </div>
              </Link>
            </div>
            <br />
            <Link to={'/educational'} className="box-1 ">
              <div className="for__bg">
                <div className="box1">
                  <img src="assets/img/Mask Group.png" alt />
                  <h2>Узбекско-Российский образовательный факультет</h2>
                  <img src="assets/img/Arrow 1.png" alt />
                </div>
              </div>
              <br />
            </Link>
          </div>
          <div className="container__title">
            <div
              className="title__partner "
            
            >
              <h1>Об институте</h1>
            </div>
          </div>
          <div className="card-4">
            <div className="box3">
              <img src="/img/53.jpg" className="img" alt="" />
            </div>
            <div className="box4">
              <p>
                Дорогие друзья! Перед вами стоит важный выбор профессионального
                пути во взрослой жизни. Это решение позволит вам стать успешными
                и счастливыми. Ташкентский фармацевтический институт открывает
                перед вами сотни дорог. Каким бы ни был выбор вашей будущей
                профессии, университет даст вам не только образование, но и
                верных друзей, надежных наставников, будущих деловых партнеров,
                наполнит смыслом и яркими красками студенческие годы. Наш
                институт — один из самых крупных вузов Узбекистана, у нас
                обучается более 5 тысяч студентов! 85 лет нас выбирают
                целеустремленные, творческие, спортивные, инициативные ребята.
                Вас ждут интересные мастер-классы и круглые столы, эксперименты в лабораториях, радость от побед в грантовых конкурсах и фестивалях, удовольствие от погружения в науку. Вы сможете создавать стартапы в студенческих конструкторских бюро, выступать с проектами в пространстве. Университет открывает перед вами возможность международного образования: мы ведем обмен студентами и преподавателями с зарубежными вузами, даем возможность продолжения обучения и за границей.
              </p>
              <br />
              <br />
              <button>
                Подробнее <img src="assets/img/Arrow 5.png" alt />
              </button>
            </div>
          </div>
          <div className="card-5">
            <div className="box5">
              <h1 className="value" akhi={9}>
                9
              </h1>
              <span>Fakultetlar</span>
            </div>
            <div className="box5">
              <h1 className="value" akhi={21000}>
                21000
              </h1>
              <span>Talabalar</span>
            </div>
            <div className="box5">
              <h1 className="value" akhi={1800}>
                1800
              </h1>
              <span>Talabalar</span>
            </div>
            <div className="box5">
              <h1 className="value" akhi={47}>
                47
              </h1>
              <span>Hamkorlar</span>
            </div>
          </div>
          <div className="container__title">
            <div
              className="title__partner"
            
            >
              <h1>Новости</h1>
            </div>
          </div>
          <div className="card-6">
            <div className="box6">
              <img src="/img/51.jpg" alt />
              <div className="cek">
                <img src="assets/img/time.png" alt />
                <p>2022-02-02 05:07:52</p>
              </div>
              <b>
                Ташкентский фармацевтический <br /> институт объявил победителей{" "}
                <br /> онлайн-конкурсов по 9 <br />
                направлениям!
              </b>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. <br />{" "}
                Rhoncus pharetra est nisi, eget a, morbi ac. Imperdiet <br />{" "}
                velit libero egestas id etiam id id.
              </p>
              <a href="#">
                <span>Подробно читать</span>
              </a>
            </div>
            <div className="box6">
              <img src="/img/52.jpg" alt />
              <div className="cek">
                <img src="assets/img/time.png" alt />
                <p>2022-02-02 05:07:52</p>
              </div>
              <b>
                Ташкентский фармацевтический <br /> институт объявил победителей{" "}
                <br /> онлайн-конкурсов по 9 <br />
                направлениям!
              </b>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. <br />{" "}
                Rhoncus pharetra est nisi, eget a, morbi ac. Imperdiet <br />{" "}
                velit libero egestas id etiam id id.
              </p>
              <a href="#">
                <span>Подробно читать</span>
              </a>
            </div>
            <div className="box6">
              <img src="assets/img/Rectangle 42.png" alt />
              <div className="cek">
                <img src="assets/img/time.png" alt />
                <p>2022-02-02 05:07:52</p>
              </div>
              <b>
                Ташкентский фармацевтический <br /> институт объявил победителей{" "}
                <br /> онлайн-конкурсов по 9 <br />
                направлениям!
              </b>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. <br />{" "}
                Rhoncus pharetra est nisi, eget a, morbi ac. Imperdiet <br />{" "}
                velit libero egestas id etiam id id.
              </p>
              <a href="#">
                <span>Подробно читать</span>
              </a>
            </div>
          </div>
          <div className="the_btn">
            <button>
              Подробнее
              <img src="assets/img/Arrow 5.png" alt />
            </button>
          </div>
        </div>
      </div>
      <div className="partner">
        <div className="title__partner">
          <h1>партнеры</h1>
        </div>
        <div className="row__partner">
          <div className="card__partner">
            <div className="img">
              <img src="assets/img/nauk.png" alt />
            </div>
            <p>Академия наук Узбекистана</p>
          </div>
          <div className="card__partner">
            <div className="img">
              <img src="assets/img/grand.png" alt />
            </div>
            <p>OOO “GRAND PHARM TRADE”</p>
          </div>
          <div className="card__partner">
            <div className="img">
              <img src="assets/img/dori.png" alt />
            </div>
            <p>“Dori Darmon” Aкционерная компания</p>
          </div>
          <div className="card__partner">
            <div className="img">
              <img src="assets/img/grand.png" alt />
            </div>
            <p>Академия наук Узбекистана</p>
          </div>
          <div className="card__partner">
            <div className="img">
              <img src="assets/img/apteka.png" alt />
            </div>
            <p>Академия наук Узбекистана </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Home;
